import './review-sections.css'

interface Initiative {
  name: string
  status: string
  verdict: string
  why: string
  bsc_perspective: string
}

interface ScorecardData {
  summary: string
  completion_rate: number
  initiatives: Initiative[]
}

interface Props {
  data: ScorecardData
}

function getBscClass(perspective: string): string {
  const p = perspective.toLowerCase()
  if (p.includes('financial')) return 'bsc-financial'
  if (p.includes('customer')) return 'bsc-customer'
  if (p.includes('process')) return 'bsc-process'
  if (p.includes('learning') || p.includes('growth')) return 'bsc-learning'
  return ''
}

function getVerdictIcon(verdict: string): { icon: string; className: string } {
  switch (verdict) {
    case 'success': return { icon: '\u2713', className: 'verdict-success' }
    case 'partial': return { icon: '\u25D1', className: 'verdict-partial' }
    case 'blocked': return { icon: '\u26A0', className: 'verdict-blocked' }
    case 'failed': return { icon: '\u2717', className: 'verdict-failed' }
    default: return { icon: '\u2014', className: '' }
  }
}

export default function ScorecardSection({ data }: Props) {
  const pct = Math.round((data.completion_rate || 0) * 100)
  const barColor = pct >= 70 ? '#2e7d32' : pct >= 40 ? '#e65100' : '#c62828'

  return (
    <div>
      <p className="section-hint">
        How your initiatives performed, with root-cause analysis for what succeeded or stalled.
      </p>

      <p className="section-narrative">{data.summary}</p>

      <div className="completion-bar-container">
        <div
          className="completion-bar-fill"
          style={{ width: `${pct}%`, background: barColor }}
        />
      </div>
      <div style={{ fontSize: 12, color: '#666', marginBottom: 12 }}>{pct}% complete</div>

      {(data.initiatives || []).map((init, i) => {
        const verdict = getVerdictIcon(init.verdict)
        return (
          <div key={i} className="review-card">
            <div className="review-card-header">
              <span className="review-card-title">
                <span className={`verdict-icon ${verdict.className}`}>{verdict.icon}</span>
                {init.name}
              </span>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                <span className={`bsc-badge ${getBscClass(init.bsc_perspective)}`}>
                  {init.bsc_perspective}
                </span>
                <span className={`status-pill status-${init.status}`}>
                  {init.status.replace('_', ' ')}
                </span>
              </div>
            </div>
            <p className="review-card-body">{init.why}</p>
          </div>
        )
      })}
    </div>
  )
}
